import React, { useState } from 'react'
import { useEffect } from 'react'
import { Row, Col, Table, Button, Accordion, Card, Collapse, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FetchBoutiqueTransactions, FetchBoutiqueB2COrderTransactions, FetchMandatorInfos, FetchArticleTypeImages, FetchReadCustomers, FetchSalutations, FetchDeleteB2COrderTransaction } from '../../fetcher'
import { ModalComponent } from '../presentational-components/ModalComponent'
import SaleTransaction from './SaleTransaction'
import B2COrderTransaction from './B2COrderTransaction'
import { DateSelect } from '../presentational-components/FilterComponents'
import DescriptionTooltip from '../presentational-components/DescriptionTooltip'
import AlertMessage from '../presentational-components/AlertMessage'
import { RenderImage } from '../presentational-components/ImageViewer'
import moment from 'moment'
import 'moment/locale/de'
import { ExportCSV } from '../presentational-components/ExportCSV'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations'
import LoadingSpinner from '../presentational-components/LoadingSpinner'
import { DetailedCustomer } from './DetailedCustomer'
import { DetailedOrder } from './DetailedOrder'
moment.locale('de')


const B2COrderBoutique = () => {

    const [transactions, setTransactions] = useState([])
    const [filteredTransactions, setFilteredTransactions] = useState([])

    const [salutations, setSalutations] = useState([])
    const [customers, setCustomers] = useState([])
    const initialCustomer = { Contact: { Name: "", Surname: "" } }
    const [customerToUpdate, setCustomerToUpdate] = useState(initialCustomer)
    const [customerSalutation, setCustomerSalutation] = useState("")

    const [orderToView, setOrderToView] = useState({ order: null, article: null, name: "" })

    const [filterOrderState, setFilterOrderState] = useState("-Bestellstatus filtern-")
    const [filterOrderProcessingState, setFilterOrderProcessingState] = useState("-Bearbeitungsstatus filtern-")
    const [orderStatesToFilter, setOrderStatesToFilter] = useState([])
    const [orderProcessingStatesToFilter, setOrderProcessingStatesToFilter] = useState([])

    const [newTransaction, setNewTransaction] = useState(false)
    const [newB2COrderTransaction, setNewB2COrderTransaction] = useState(false)
    const [isFAEX, setIsFAEX] = useState(false)

    const [showCustomer, setShowCustomer] = useState(false)
    const handleCloseCustomer = () => setShowCustomer(prev => prev = false)
    const handleCloseCustomerAfterSave = () => {
        handleCloseCustomer()
        FetchReadCustomers(setCustomers, openAlert, signal, "B2COrderBoutique")
    }
    const handleShowCustomer = () => setShowCustomer(true)

    const [showOrder, setShowOrder] = useState(false)
    const handleCloseOrder = () => setShowOrder(false)
    const handleShowOrder = () => setShowOrder(true)

    const returnFromNewTransaction = () => {
        setNewTransaction(false)

        reload()
    }

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [articleDataReady, setArticleDataToReady] = useState(false)

    const addingImages = (articleTypeImages) => {
        let copiedTransactions = [...transactions]
        articleTypeImages.forEach(image => copiedTransactions.flatMap(x => x.SoldArticles).filter(x => x.ArticleId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setTransactions(copiedTransactions)
        setFilteredTransactions(copiedTransactions)
    }

    const setTransactionsInitially = (transactions) => {
        transactions.sort((a, b) =>
            (moment(moment(b.Date, "DD.MM.YYYY").format("YYYYMMDD"))) - (moment(moment(a.Date, "DD.MM.YYYY").format("YYYYMMDD"))))
        setTransactions(transactions)
    }

    useEffect(() => {
        FetchBoutiqueB2COrderTransactions(setTransactionsInitially, setFilteredTransactions, openAlert, setArticleDataToReady)
        setFilteredTransactions(transactions)
    }, []);

    const [taskName, setTaskName] = useState("Lade Bestellungen...")
    const controller = new AbortController()
    const signal = controller.signal

    useEffect(() => {
        FetchReadCustomers(setCustomers, openAlert, signal, "B2COrderBoutique")
    }, [])

    useEffect(() => {
        FetchSalutations(setSalutations, openAlert)
    }, [])

    useEffect(() => {
        const stateFilterOptions = [...new Set(transactions.flatMap(x => x.SoldArticles).map(article => article.OrderState.OrderState))]
        setOrderStatesToFilter(stateFilterOptions)

        const processingStateFilterOptions = [...new Set(transactions.flatMap(x => x.SoldArticles).map(article => article.OrderProcessingState.OrderProcessingState))]
        setOrderProcessingStatesToFilter(processingStateFilterOptions)
    }, [transactions])

    const reload = () => {
        FetchReadCustomers(setCustomers, openAlert, signal, "B2COrderBoutique")
        FetchBoutiqueB2COrderTransactions(setTransactionsInitially, setFilteredTransactions, openAlert, setArticleDataToReady, signal, "B2COrderBoutique")
    }

    const [dayReport, setIsDayReport] = useState(false)
    const isDayReport = () => {
        let dates = [...new Set(filteredTransactions.map(x => x.Date))]
        if (dates.length !== 1) setIsDayReport(false)
        else setIsDayReport(true)
    }

    useEffect(() => {
        isDayReport()
    }, [filteredTransactions])


    useEffect(() => {
        if (JSON.parse(sessionStorage.getItem("loginInformation")).StorageType === "FAEX") {
            setIsFAEX(true)
        }
    }, [])

    useEffect(() => {
        console.log("Object.keys(customerToUpdate).includes('ContactSysId')", customerToUpdate)
        if (Object.keys(customerToUpdate).includes("ContactSysId")) {
            setCustomerToUpdate(prev => prev = customers.filter(x => x.ContactSysId == prev.ContactSysId)[0])
            setCustomerSalutation(prev => prev = (customerToUpdate.Contact.Name != "" && customerToUpdate.Contact.Surname != "") ? customerToUpdate.Contact.Name + ", " + customerToUpdate.Contact.Surname : customerToUpdate.Contact.Name + " " + customerToUpdate.Contact.Surname)
        }
    }, [customers])

    const [expandedRows, setExpandedRows] = useState([])

    const expandRow = (index) => {
        const expandedRowsCopy = [...expandedRows]
        expandedRowsCopy.includes(index) ? expandedRowsCopy.splice(expandedRowsCopy.indexOf(index), 1) : expandedRowsCopy.push(index)
        setExpandedRows(expandedRowsCopy)
    }

    const getIsExpandedRow = (index) => {
        return(expandedRows.includes(index))
    }

    const filterTransactions = (searchFilterInput, dateFilterInput, paymentFilterInput, filterOrderState, filterOrderProcessingState) => {
        let transactionsCopy = [...transactions]

        transactionsCopy = transactionsCopy.filter(transaction => transaction.TransactionSysId.toLowerCase().includes(searchFilterInput)
            || transaction.Date.includes(searchFilterInput)
            || (transaction.PointOfOrdering !== undefined && transaction.PointOfOrdering !== null && transaction.PointOfOrdering.toString().toLowerCase().includes(searchFilterInput))
            || transaction.Payment.toLowerCase().includes(searchFilterInput)
            || transaction.SoldArticles.some(article => article.ArticleIdFaex.toLowerCase().includes(searchFilterInput)
                || article.ArticleName.toLowerCase().includes(searchFilterInput)
                || article.ArticleIdFaex.toLowerCase().includes(searchFilterInput)
                || article.DesignerName.toLowerCase().includes(searchFilterInput)
                || transaction.Name.toLowerCase().includes(searchFilterInput)
                || transaction.Surname.toLowerCase().includes(searchFilterInput)
                || EnumValueTranslations(article.OrderState.OrderState).toLowerCase().includes(searchFilterInput)
                || article.Remark.toLowerCase().includes(searchFilterInput)
                || article.Colour.toLowerCase().includes(searchFilterInput)
                || article.Size.toLowerCase().includes(searchFilterInput)))

        if (dateFilterInput != "") {
            const startDate = moment(dateFilterInput.start._d).format("MM/DD/YYYY")
            const endDate = moment(dateFilterInput.end._d).format("MM/DD/YYYY")
            transactionsCopy = transactionsCopy.filter(transaction => ((moment(moment(transaction.Date, "DD.MM.YYYY").format("MM/DD/YYYY"))).isSameOrBefore(endDate) &&
                (moment(moment(transaction.Date, "DD.MM.YYYY").format("MM/DD/YYYY"))).isSameOrAfter(startDate)))
        }

        if (paymentFilterInput != "" && paymentFilterInput != "---") {
            transactionsCopy = transactionsCopy.filter(transaction => transaction.Payment == paymentFilterInput)
        }

        if (filterOrderState !== "" && filterOrderState !== "-Bestellstatus filtern-" && filterOrderState !== "default") {
            transactionsCopy = transactionsCopy.filter(transaction => transaction.SoldArticles.some(x => EnumValueTranslations(x.OrderState.OrderState) === filterOrderState))
        }

        if (filterOrderProcessingState !== "" && filterOrderProcessingState !== "-Bearbeitungsstatus filtern-" && filterOrderProcessingState !== "default") {
            transactionsCopy = transactionsCopy.filter(transaction => transaction.SoldArticles.some(x => EnumValueTranslations(x.OrderProcessingState.OrderProcessingState) === filterOrderProcessingState))
        }

        return transactionsCopy
    }

    const [searchInput, setSearchInput] = useState("")
    const handleSearchInput = (e) => {
        const searchFilterInput = (e.target.value).toLowerCase()
        setSearchInput(searchFilterInput)

        const filteredTransactionsCopy = filterTransactions(searchFilterInput, dateSelect, paymentSelect, filterOrderState, filterOrderProcessingState)
        setFilteredTransactions(filteredTransactionsCopy)
        setExpandedRows([])
    }

    const [filterBar, setFilterBar] = useState(false)

    const [dateSelect, setDateSelect] = useState("")
    const handleDatePickerCallback = (start, end) => {
        const dateFilter = { start, end }
        setDateSelect(dateFilter)

        const filteredTransactionsCopy = filterTransactions(searchInput, dateFilter, paymentSelect, filterOrderState, filterOrderProcessingState)
        setFilteredTransactions(filteredTransactionsCopy)
        setExpandedRows([])
    }
    const handleClearFilter = () => {
        setDateSelect("")

        const filteredTransactionsCopy = filterTransactions(searchInput, "", paymentSelect, filterOrderState, filterOrderProcessingState)
        setFilteredTransactions(filteredTransactionsCopy)
        setExpandedRows([])
    }

    const handleOrderStateFilter = (e) => {
        e.preventDefault()
        const orderState = e.target.value
        setFilterOrderState(orderState)

        const filteredTransactionsCopy = filterTransactions(searchInput, dateSelect, paymentSelect, orderState, filterOrderProcessingState)
        setFilteredTransactions(filteredTransactionsCopy)
    }

    const handleOrderProcessingStateFilter = (e) => {
        e.preventDefault()
        const orderProcessingState = e.target.value
        setFilterOrderProcessingState(orderProcessingState)

        const filteredTransactionsCopy = filterTransactions(searchInput, dateSelect, paymentSelect, filterOrderState, orderProcessingState)
        setFilteredTransactions(filteredTransactionsCopy)
    }

    const [paymentSelect, setPaymentSelect] = useState("---")
    const handlePaymentSelectChange = (e) => {
        e.preventDefault()
        const payment = e.target.value
        setPaymentSelect(payment)

        const filteredTransactionsCopy = filterTransactions(searchInput, dateSelect, payment, filterOrderState)
        setFilteredTransactions(filteredTransactionsCopy)
        setExpandedRows([])
    }
    const PaymentSelect = () => {
        const payments = [...new Set(transactions.map(x => x.Payment))]

        return (
            <FormControl className="filterForm" defaultValue={paymentSelect} as="select" size="sm" onChange={handlePaymentSelectChange}>
                <option>---</option>
                {payments.map(x => <option>{x}</option>)}
            </FormControl>
        )
    }

    const [sortOrderAsc, setSortOrderAsc] = useState(true)
    const [sortField, setSortField] = useState("")

    const sortColumn = (e, field) => {
        if(e != null && e != undefined)
            e.preventDefault()
        let sortOrderAscTemp = sortOrderAsc

        if (sortField === field) {
            setSortOrderAsc(!sortOrderAsc)
            sortOrderAscTemp = (!sortOrderAsc)
        } else {
            setSortField(field)
            setSortOrderAsc(true)
            sortOrderAscTemp = true
        }

        if (field === "Date") {
            const transactionCopyForDate =
                [...transactions].sort((a, b) =>
                    sortOrderAscTemp === true ? (moment(moment(a.Date, "DD.MM.YYYY").format("YYYYMMDD"))) - (moment(moment(b.Date, "DD.MM.YYYY").format("YYYYMMDD")))
                        : (moment(moment(b.Date, "DD.MM.YYYY").format("YYYYMMDD"))) - (moment(moment(a.Date, "DD.MM.YYYY").format("YYYYMMDD"))) )

            setFilteredTransactions(transactionCopyForDate)
        } else {
            const transactionCopy =
                [...transactions].sort((a, b) => {
                    if (a[field] < b[field]) {
                        return sortOrderAscTemp === true ? -1 : 1;
                    }
                    if (a[field] > b[field]) {
                        return sortOrderAscTemp === true ? 1 : -1;
                    }

                    return 0;
                })
            setFilteredTransactions(transactionCopy)
        }
    }

    const [transactionSysIdToDelete, setTransactionSysIdToDelete] = useState("")
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const handleShowDeleteModal = () => setShowDeleteModal(true)
    const handleCloseDeleteModal = () => setShowDeleteModal(false)

    const removeB2COrderTransaction = () => {
        FetchDeleteB2COrderTransaction(transactionSysIdToDelete, openAlert, reload)
        handleCloseDeleteModal()
    }

    const openRemoveModal = (e, transactionSysId) => {
        e.preventDefault()
        console.log("openRemoveModal11", transactionSysId)
        setTransactionSysIdToDelete(transactionSysId)
        handleShowDeleteModal()
    }


    const openOrder = (e, order, article, name) => {
        e.preventDefault()
        e.stopPropagation()
        setCustomerToUpdate(customers.find(x => x.ContactSysId === order.ContactSysId))
        setOrderToView({ order, article, name })
        setCustomerSalutation(name)
        handleShowOrder()
    }

    const [saleForOrderTransaction, setSaleForOrderTransaction] = useState(false)
    const [orderTransactionForSale, setOrderTransactionForSale] = useState([])

    const handleSetSale = (transaction) => {

        setOrderTransactionForSale(transaction)
        setSaleForOrderTransaction(true)
    }

    const getCsvData = () => {
        let csvData = []
        filteredTransactions.forEach(y => {
            y.SoldArticles.map(x => {
                let articles = {
                    "Datum": y.Date,
                    "Artikelnr.": x.ArticleIdFaex,
                    "Artikelnr. Designer": x.ArticleNumberDesigner,
                    "Artikelname": x.ArticleName,
                    "Designername": x.DesignerName,
                    "Farbe": x.Colour,
                    "Größe": x.Size,
                    "Anzahl": y.Type !== "Sales" ? (-1)*x.Count : x.Count,
                    "Einzelpreis": x.PriceUnit,
                    "Vk-Preis": x.PriceAtTimeOfSale,
                    "Gesamtpreis": y.Type !== "Sales" ? (-1)*parseFloat(x.Count * parseFloat(x.PriceAtTimeOfSale)) : parseFloat(x.Count * parseFloat(x.PriceAtTimeOfSale))
                }
                csvData.push(articles)
            })
        })
        return (csvData)
    }
    
    const sum = () => {
        let sum = filteredTransactions.map(x => parseFloat(x.Total)).reduce((a, b) => a + b, 0)
        let dailyTotal = parseFloat(sum).toFixed(2).replace('.', ',') + "€"

        return (dailyTotal)
    }

    if (saleForOrderTransaction === true) return (<SaleTransaction reload={returnFromNewTransaction} orderTransactions={orderTransactionForSale} setNewTransaction={() => setSaleForOrderTransaction(false)}/>)
    else if (newB2COrderTransaction === true) return (<B2COrderTransaction setNewB2CTransaction={setNewB2COrderTransaction} reload={returnFromNewTransaction} />)
    else {

        return (
            <div>
                <div className="tablet-center tablet-saletransactions">
                    <h1>Bestellungen</h1>
                    <div className="flex-linebreak"></div>
                    <Button variant="secondary" className="booking-btn" onClick={() => { setNewB2COrderTransaction(true) }}>Neue Bestellung</Button>
                    <div className="flex-linebreak"></div>
                </div>
                
                <div className="tablet-transactions">
                    <div className="inline">
                        <FormControl className="globalSearch" as="input" placeholder="Suche..." onChange={handleSearchInput}></FormControl>
                        <FormControl className="globalSearch" as="select" value={filterOrderState}
                            focusFirstItemOnShow='keyboard' onChange={(e) => handleOrderStateFilter(e)}>
                            <option value="default">-Bestellstatus filtern-</option>
                            {orderStatesToFilter.map(state =>
                                <option>{EnumValueTranslations(state)}</option>)
                            }
                        </FormControl>
                        <FormControl className="globalSearch" as="select" value={filterOrderProcessingState}
                            focusFirstItemOnShow='keyboard' onChange={(e) => handleOrderProcessingStateFilter(e)}>
                            <option value="default">-Bearbeitungsstatus filtern-</option>
                            {orderProcessingStatesToFilter.map(state =>
                                <option>{EnumValueTranslations(state)}</option>)
                            }
                        </FormControl>
                    </div>
                    
                    <Table className="table-sm table-sales-striped-immediate table-width-narrow">
                        <thead className="sticky-table-header">
                            <tr>
                                <th>Transaktion ID</th>
                                <th>Datum
                                    <a href="" className="sort-link" onClick={(e) => sortColumn(e, 'Date')}>&#8593; &#8595;</a>
                                    {/*<a href="" className="sort-link" onClick={(e) => sortColumn(e, 'Date')}>&#8595;</a>*/}
                                </th>
                                <th>Art
                                    <a href="" className="sort-link" onClick={(e) => sortColumn(e, 'Type')}>&#8593; &#8595;</a>
                                </th>
                                {isFAEX != undefined && isFAEX ? <th>Bestellungsort</th> : <></>}
                                <th>Vorname</th>
                                <th>Name</th>
                                <th>Telefonnummer</th>
                                <th>E-mail</th>
                                <th>Zahlung</th>
                                <th>Anzahl
                                    <a href="" className="sort-link" onClick={(e) => sortColumn(e, 'Count')}>&#8593; &#8595;</a>
                                    {/*<a href="" className="sort-link" onClick={(e) => sortColumn(e, 'Count', "asc")}>&#8595;</a>*/}
                                </th>
                                <th>Summe
                                    <a href="" className="sort-link" onClick={(e) => sortColumn(e, 'Total')}>&#8593; &#8595;</a>
                                    {/*<a href="" className="sort-link" onClick={(e) => sortColumn(e, 'Total', "asc")}>&#8595;</a>*/}
                                </th>
                                <th>Ausstehender Betrag
                                    <a href="" className="sort-link" onClick={(e) => sortColumn(e, 'BillToPayTotal')}>&#8593; &#8595;</a>
                                    {/*<a href="" className="sort-link" onClick={(e) => sortColumn(e, 'Total', "asc")}>&#8595;</a>*/}
                                </th>
                                <th></th>
                                <th className="filterIndicator" onClick={() => setFilterBar(prev => prev = !filterBar)}>&#8711; Filtermenü</th>
                            </tr>
                            {filterBar ? <tr>
                                <th></th>
                                <th>{DateSelect(handleDatePickerCallback, handleClearFilter)}</th>
                                <th></th>
                                {isFAEX != undefined && isFAEX ? <th></th> : <></>}
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th>{PaymentSelect()}</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                {/*<th>{DateSelect(handleDatePickerCallback)}</th>*/}
                                {/*<th>{StatusSelect(selectFilterInput, selectFilteredElements, [...new Set(outgoingTransactions.map(x => x.State))])}</th>*/}
                                <th></th>
                            </tr> : null}
                        </thead>
                        <tbody>
                            {filteredTransactions.map((transaction, index) =>
                                <>
                                    <tr className="salesboutique-mainrow">
                                        <td>
                                            <Button variant="light" onClick={() => expandRow(transaction.TransactionSysId)} aria-controls={transaction.TransactionSysId}
                                                aria-expanded={getIsExpandedRow(transaction.TransactionSysId)} className="table-card-header">
                                                {transaction.TransactionSysId}
                                            </Button>
                                        </td>
                                        <td>{transaction.Date}</td>
                                        <td>{EnumValueTranslations(transaction.Type)}</td>
                                        {isFAEX != undefined && isFAEX ? <td>{transaction.PointOfOrdering}</td> : <></>}
                                        <td>{transaction.Name}</td>
                                        <td>{transaction.Surname}</td>
                                        <td>{transaction.Phone}</td>
                                        <td>{transaction.Email}</td>
                                        <td>{transaction.Payment}</td>
                                        <td className="numberColumn">{transaction.Count}</td>
                                        <td className="numberColumn">{parseFloat(transaction.Total).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td className="numberColumn">{parseFloat(transaction.BillToPayTotal).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td>
                                            {/*15.12.22 RB: Disabled for now, since Orders are handled differently and independently from sales for now*/}
                                            {/*<OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip("Verkauf abschließen (Achtung: Bestellung wird vorerst noch nicht gelöscht!)")}>*/}
                                            {/*    <Button variant="secondary" disabled size="sm" onClick={() => handleSetSale(transaction)}>&#8618;</Button>*/}
                                            {/*</OverlayTrigger>*/}
                                        </td>
                                        <td>
                                            <OverlayTrigger className="remove-order-td" placement="bottom" overlay={<Tooltip> Bestellung löschen </Tooltip>}>
                                                <a className="remove-order" href="" onClick={(e) => openRemoveModal(e, transaction.TransactionSysId)} variant="secondary">&#10060;</a>
                                            </OverlayTrigger>
                                        </td>
                                    </tr>

                                    <Collapse in={getIsExpandedRow(transaction.TransactionSysId)}>
                                            <td colSpan="6" className="td-nomargin">
                                            <div id={transaction.TransactionSysId} className="salesBoutique-child-div">
                                                <thead className="sticky-table-header">
                                                    <tr className="salesboutique-childheaderrow">
                                                        <th></th>
                                                        <th>Ansicht</th>
                                                        <th>Datum</th>
                                                        <th>Bestellstatus</th>
                                                        <th>Bearbeitungsstatus</th>
                                                        <th>Designername</th>
                                                        <th>Artikel ID</th>
                                                        <th>Artikelname</th>
                                                        <th>Größe</th>
                                                        <th>Farbe</th>
                                                        <th>Anzahl</th>
                                                        <th>Einzelpreis</th>
                                                        <th>Preisänderung</th>
                                                        <th>Gesamtpreis</th>
                                                        <th>Zahlung</th>
                                                        <th>Bemerkung</th>
                                                    </tr>
                                                </thead>
                                                    {transaction.SoldArticles.map(article =>
                                                        <>
                                                            <tr>
                                                                <td>
                                                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Bestellung öffnen</Tooltip>}>
                                                                        <a className="edit-button" onClick={(e) => openOrder(e, transaction, article, transaction.Name + ", " + transaction.Surname)}>&#9998;</a>
                                                                    </OverlayTrigger>
                                                                </td>
                                                                <td>{RenderImage(article.Image)}</td>
                                                                <td>{transaction.Date}</td>
                                                                <td>{EnumValueTranslations(article.OrderState.OrderState)}</td>
                                                                <td>{EnumValueTranslations(article.OrderProcessingState.OrderProcessingState)}</td>
                                                                <td>{article.DesignerName}</td>
                                                                <td>{article.ArticleIdFaex}</td>
                                                                <td>{article.ArticleName}</td>
                                                                <td>{article.Size}</td>
                                                                <td>{article.Colour}</td>
                                                                <td className="numberColumn">{article.Count}</td>
                                                                <td className="numberColumn">{parseFloat(article.PriceUnit).toFixed(2).replace('.', ',') + "€"}</td>
                                                                <td className="numberColumn">{parseFloat((-1) * (parseFloat(article.PriceUnit) - parseFloat(article.PriceAtTimeOfSale))).toFixed(2).replace('.', ',') + "€"}</td>
                                                                <td className="numberColumn">{parseFloat(article.Count * parseFloat(article.PriceAtTimeOfSale)).toFixed(2).replace('.', ',') + "€"}</td>
                                                                <td className="numberColumn">{parseFloat(article.Count * parseFloat(article.PrepaymentAtTimeOfSale)).toFixed(2).replace('.', ',') + "€"}</td>
                                                                <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(article.Remark)}>
                                                                    <td className="dropdown-article-description">{article.Remark}</td>
                                                                </OverlayTrigger>
                                                            </tr>
                                                        </>
                                                    )}
                                                </div>
                                            </td>
                                            </Collapse>
                                        </>
                            )}

                            {/*{dayReport &&*/}
                            {filteredTransactions.length > 0 &&
                            <tr className="salesboutique-mainrow dayReport-row">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Summe:</td>
                                <td className="numberColumn">{filteredTransactions.map(x => x.Count).reduce((a, b) => a + b, 0)}</td>
                                <td className="numberColumn">{sum()}</td>
                                <td><ExportCSV className="sales-export-btn" csvData={getCsvData()} fileName={"Verkäufe"} /></td>
                            </tr>
                            }
                            </tbody>
                    </Table>
                </div>

                <ModalComponent handleShow={showDeleteModal} handleClose={handleCloseDeleteModal} handleSubmit={removeB2COrderTransaction}
                    reload={reload} modalTitle="Bestellung löschen" modalBody="Möchten Sie die Bestellung wirklich löschen?" />
                <ModalComponent handleShow={showCustomer} handleClose={handleCloseCustomer} reload={reload}
                    modalTitle={"Kunden bearbeiten: '" + customerToUpdate.Contact.Name + ", " + customerToUpdate.Contact.Surname + "'"}
                    modalBody={<DetailedCustomer customerToUpdate={customerToUpdate} salutations={salutations.Salutations} handleCloseCustomer={handleCloseCustomerAfterSave} openAlert={openAlert} />} formTitle="update-customer-form" />
                <ModalComponent handleShow={showOrder} handleClose={handleCloseOrder} reload={reload}
                    modalTitle={"Bestellung bearbeiten: "}
                    modalBody={<DetailedOrder customerOrder={orderToView} customerSalutation={customerSalutation} handleOpenCustomer={handleShowCustomer} handleCloseOrder={handleCloseOrder} openAlert={openAlert} />} formTitle="update-order-form" />

                <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
                <LoadingSpinner task={taskName} area={"B2COrderBoutique"} />
            </div>
        )
    }
}

export default B2COrderBoutique